var map = {
	"./1.png": "0ca1",
	"./2.png": "b9af",
	"./3.png": "c2e4",
	"./4.png": "1105",
	"./5.png": "9310",
	"./Background_wave.png": "713d",
	"./Bigplus.png": "8209",
	"./FAQs.png": "e96a",
	"./Get_Started.png": "e7c7",
	"./Image.png": "a594",
	"./Image_placeholder.png": "d314",
	"./Insta.png": "979d",
	"./Littleminus.png": "63c1",
	"./Pencil.png": "019f",
	"./Polygon.png": "72feb",
	"./Profile_icon.png": "3d15",
	"./Rectangle.png": "e46a",
	"./Section_land.png": "643b",
	"./Squiggles.png": "0dc4",
	"./blue_check.png": "a044",
	"./blue_tik.png": "3f26",
	"./blue_tik_s.png": "2a37",
	"./bubbles.png": "bbf5",
	"./carousel_1.png": "3250",
	"./carousel_2.png": "6dd8a",
	"./cross.png": "c077",
	"./dot.png": "36e0",
	"./edit_icon.png": "0ccf",
	"./emp_img.png": "99a9",
	"./employees.png": "7cf7",
	"./export.png": "707c",
	"./gestaltra_logo-reversed.png": "2b1e",
	"./gestaltra_logo.png": "ded2",
	"./gestaltra_logo_grey.png": "c1b2",
	"./gestaltra_logo_white.png": "5dcf",
	"./grey_tik.png": "5863",
	"./header-screen.png": "b43d",
	"./hide-comment.png": "5686",
	"./holding.png": "de50",
	"./icon_fav.png": "4dc0",
	"./landing_img1.png": "e002",
	"./landing_img111.png": "01c4",
	"./leadership.png": "20c7",
	"./leadership_img.png": "052e",
	"./linkdIn.png": "36ae",
	"./logo.png": "cf05",
	"./logout-icon.png": "8aa6",
	"./marketing_img.png": "ec40",
	"./org_img.png": "728c",
	"./organisation.png": "6324",
	"./pc.png": "6b06",
	"./pc_img.png": "734f",
	"./people-header.png": "8b3f",
	"./people.png": "6432",
	"./right_img.png": "0acc",
	"./smile1.png": "713c",
	"./smile2.png": "921c",
	"./smile3.png": "498e",
	"./smile4.png": "f6da",
	"./smile5.png": "7d45",
	"./step1-1.png": "c8c2",
	"./step1-2.png": "13b4",
	"./step1-3.png": "d0c9",
	"./step1-4.png": "4925",
	"./tick.png": "2bd4",
	"./time_out_img.png": "557d",
	"./user.png": "c121",
	"./vector.png": "41c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";